// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "scripts/" + ({"2004":"dynamicImportBvtCustomPlaylist","3677":"dynamic-import-insitepanel"}[chunkId] || chunkId) + "." + {"2004":"7911f23d7da9369168ea","3677":"f5693def0fbed8d83627","9185":"930abf2a230251a150a2"}[chunkId] + ".js";
};